import { Column } from '@/shared/Column'
import { TemplateTable } from '@/template/table'
import { TemplateToolbar } from '@/template/toolbar'
import React from 'react'
import { BoxContactProps } from '../interface'

export const BoxContact: React.FC<BoxContactProps> = (
  props: BoxContactProps
) => {
  const columns: Column[] = [
    { index: 5, hidden: true },
    { index: 7, hidden: true }
  ]

  return (
    <div>
      <TemplateToolbar
        showImport={false}
        showCreate={false}
        showBatch={false}
        onSearch={props.onSearch}
      />
      <TemplateTable
        columns={columns}
        selectable={true}
        selectionType='radio'
        data={props.data}
        onSelect={props.onSelect}
        pagination={props.pagination}
        size={props.size}
      />
    </div>
  )
}
